<div>
    <div class="qr-container mb-3">
        <qrcode #qrcode [qrdata]="getQRData()"></qrcode>
    </div>
    <div hidden>
        <app-print-qr-codes [studentCodes]="[Student]" [hideButton]="true"></app-print-qr-codes>
    </div>
    <div class="qr-actions">
      <a class="pointer" (click)="emailQR()" *ngIf="!isParent" ngbTooltip="Email"><i class="far fa-envelope fa-lg"></i></a>
      <a class="pointer" (click)="printQR()" ngbTooltip="Print"><i class="far fa-print fa-lg"></i></a>
      <a class="pointer" (click)="downloadQR()" ngbTooltip="Download"><i class="far fa-download fa-lg"></i></a>
    </div>
</div>
<app-email-qr-modal #emailModal [openModalButtonVisible]="false"></app-email-qr-modal>